import {createBrowserHistory} from 'history';

export const basename = process.env.REACT_APP_BASENAME || '';

export default createBrowserHistory({basename});
